import * as R from 'ramda'
import {
    ADD_FILTER_TAG_IDS_SUCCESS,
    //FETCH_NOTIFIC_COMMENTS_IDS_SUCCESS,
    //REMOVE_NOTIFIC_COMMENTS_IDS_SUCCESS

} from '../actionTypes'

const InitialState = [];

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case ADD_FILTER_TAG_IDS_SUCCESS:
            return [...payload]
        /*case FETCH_NOTIFIC_COMMENTS_IDS_SUCCESS:
            return [...state, ...payload]
        case REMOVE_NOTIFIC_COMMENTS_IDS_SUCCESS:
            return [...payload]*/
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/filterTagIds.js